'use client'

import { Slider } from '@/core/ui/atoms/slider'
import React from 'react'
import { Slides } from '../models/slides.model'
import { RemoteImage } from '@/core/ui/atoms/remote-image'

interface Props {
  sliders: Slides[]
}

export const MainBanner: React.FC<Props> = ({ sliders }) => {
  const { description, images, title } = sliders[0]

  return (
    <>
      <Slider
        slides={images.map((image, index) => {
          return (
            <div
              style={{ height: '440px' }}
              key={image.id}
              className='relative h-80 w-full rounded-lg'
            >
              <RemoteImage
                alt={`Slide ${index + 1}`}
                fill
                src={image?.original_url}
                className='rounded-lg object-fill'
              />
              <div className='absolute inset-0 bg-[linear-gradient(180deg,_rgba(165,_165,_165,_0)_59.95%,_rgba(242,_242,_242,_0.25)_85.4%,_rgba(242,_242,_242,_0.5)_100%)]' />

              <div className='absolute bottom-0 left-0 w-full p-6 text-center'>
                <h2
                  className='text-mountain-bluebird text-4xl font-bold'
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                <p
                  className='text-mountain-bluebird text-sm font-semibold [word-spacing:6px]'
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>
            </div>
          )
        })}
        slidesPerView={1}
        showDots
        autoPlay
        delay={3000}
        className='sm:px-5'
      />
    </>
  )
}
